var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,20.5h-2c-0.552,0 -1,-0.448 -1,-1v-2c0,-0.552 0.448,-1 1,-1h2c0.552,0 1,0.448 1,1v2c0,0.552 -0.448,1 -1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,9.19v7.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,20.5h-2c-0.552,0 -1,-0.448 -1,-1v-2c0,-0.552 0.448,-1 1,-1h2c0.552,0 1,0.448 1,1v2c0,0.552 -0.448,1 -1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,20.5h-2c-0.552,0 -1,-0.448 -1,-1v-2c0,-0.552 0.448,-1 1,-1h2c0.552,0 1,0.448 1,1v2c0,0.552 -0.448,1 -1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.155,9.19h-8.31c-1.571,0 -2.845,-1.274 -2.845,-2.845v0c0,-1.571 1.274,-2.845 2.845,-2.845h8.31c1.571,0 2.845,1.274 2.845,2.845v0c0,1.571 -1.274,2.845 -2.845,2.845Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,16.5v-2c0,-1.105 0.895,-2 2,-2h10c1.105,0 2,0.895 2,2v2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0h24v24h-24v-24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/Integrations.68f8fd2bcbbbc55e6883bb806985b9a1.svg";
export { ForwardRef as ReactComponent };